import React, { useEffect, useState, Fragment } from 'react'
import { Card, Col, Container, Form, Row} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import {obtenerComboInstanciaGestion } from '../../../store/actions/recepciona-caso-action'
import { useLocation, useNavigate } from 'react-router-dom'
import {LoadingComponent, Auth} from 'recupero-comunes'
import Mensajes from '../../mensajes'

const AdministraciónCaso = ({setIsAmbito,isAmbito, formik, setShowToast, showToast}) => {
  const [loading, setLoading]=useState(false)
  const data_recepciona = useSelector((state) => state.recepcionaCasoReducer)
  const { cfg_form41, datosGestion,comboAmbitoGestion,comboInstanciaGestion,respuestaRecepcion } = data_recepciona
  const {esAbogado }=Auth.currentUser()
  const [idCarpetaResExt, setIdCarpetaResExt] = useState('')
  const [codAmbitoGestion, setCodAmbitoGestion] = useState('')
  const [codIntanciaGestion, setCodIntanciaGestion] = useState('')
  const [isInstancia, setIsInstancia] = useState(true)
  const [fechaAudiencia, setFechaAudiencia] = useState("")
  
  const queryState=JSON.parse(localStorage.getItem('filtrosRecuperoDirecto'))

  const history =useNavigate()
  const dispatch 
  = useDispatch()
  useEffect(()=>{
  },[esAbogado])
  useEffect(()=>{
    if(respuestaRecepcion && respuestaRecepcion.respuestaRecepcion["code"]===1){
      setTimeout(()=> history('/area-trabajo-recupero-directo',{state:{queryState}}),2000)      
    }
  },[respuestaRecepcion])
  useEffect(()=>{
    if (datosGestion &&
      datosGestion.datosGestion[0]['codAmbitoGestion'] !== undefined &&
      datosGestion.datosGestion[0]['codAmbitoGestion'] !== null &&
      datosGestion.datosGestion[0]['codAmbitoGestion'] !== ''){
        setLoading(true)
        let query = Buffer.from(
          JSON.stringify({"tipoGestion":datosGestion && datosGestion.datosGestion[0]["codTipoGestion"],
          "ambitoGestion":datosGestion &&
          datosGestion.datosGestion[0]['codAmbitoGestion'] , 
          "idModoIngreso":238001
          })
        ).toString('base64')
        dispatch(obtenerComboInstanciaGestion(query)).then(()=>setLoading(false))
       
        setIsInstancia(false)
       
      }
      
  },[datosGestion])
  useEffect(() => {
    setIdCarpetaResExt(
      datosGestion &&
        datosGestion.datosGestion[0]['idCarpetaResExt'] !== undefined &&
        datosGestion.datosGestion[0]['idCarpetaResExt'] !== null &&
        datosGestion.datosGestion[0]['idCarpetaResExt'] !== ''
        ? datosGestion.datosGestion[0]['idCarpetaResExt']
        : ''
    )
    setCodAmbitoGestion(
      datosGestion &&
        datosGestion.datosGestion[0]['codAmbitoGestion'] !== undefined &&
        datosGestion.datosGestion[0]['codAmbitoGestion'] !== null &&
        datosGestion.datosGestion[0]['codAmbitoGestion'] !== ''
        ? datosGestion.datosGestion[0]['codAmbitoGestion']
        : ''
    )
    setCodIntanciaGestion(
      233001
    )
    setFechaAudiencia(
      datosGestion &&
        datosGestion.datosGestion[0]['fecAudienciaFormat'] !== undefined &&
        datosGestion.datosGestion[0]['fecAudienciaFormat'] !== null &&
        datosGestion.datosGestion[0]['fecAudienciaFormat'] !== ''
        ? convertirFecha(datosGestion.datosGestion[0]['fecAudienciaFormat'])
        : ''
    )
  }, [datosGestion])
  
  const convertirFecha = (fecha) => {
    if (fecha !== null && typeof fecha !== undefined){
      
      const [dia, mes, ano] = fecha?.split('-')
      const fechaFormat = [ano, mes, dia].join('-')
  
      return fechaFormat
    }else return null
  }
  const hoy = () => {
    const fecha = new Date()
    const hoy = fecha.toISOString().split('T')[0]
    return hoy
  }
  const handleCloseToast = () => {
    setShowToast(false);
  }
  return (
    <>

      <Container>
    
        <Card className='mt-1 '>
          <Card.Header
            className='mt-0 mb-0'
            as='h6'
            style={{ backgroundColor: '#D9EDF6', color: '#8578CD' }}
          >
            {cfg_form41
              ? cfg_form41.cfg_form41['recepcasoasignadodef-title-admcaso']
              : ''}
          </Card.Header>
          <Container>
            <Container>
              {cfg_form41 ? (
                <div>
                  <Row>
                    <Col md="2">
                      <Form.Label
                        className='mb-0 mt-3'
                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                      >
                        {
                          cfg_form41.cfg_form41[
                            'recepcasoasignadodef-input-carpetaresp'
                          ]
                        }
                      </Form.Label>{' '}
                      <br />
                      <Form.Control
                        className='mt-2'
                        autoComplete='off'
                        value={
                          (formik.values.idCarpetaResExt =
                            idCarpetaResExt !== undefined && idCarpetaResExt)
                        }
                        onChange={(e) => {
                          formik.handleChange(e)
                          setIdCarpetaResExt(e.target.value)
                        }}
                        name='idCarpetaResExt'
                        error={formik.errors.idCarpetaResExt}
                      ></Form.Control>
                      {formik.errors.idCarpetaResExt ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.idCarpetaResExt}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                    </Col>
                    <Col md="3">
                      <Form.Label
                        className=' mb-0  mt-3'
                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                      >
                        {
                          cfg_form41.cfg_form41[
                            'recepcasoasignadodef-cmb-ambitogest'
                          ]
                        } *
                      </Form.Label>
                      <br />
                      <Form.Select
                        className='mt-2'
                        aria-label='Default select example'
                        onChange={(e) => {
                          formik.handleChange(e)
                          setCodAmbitoGestion(e.target.value)
                         if(e.target.value!=='' ){
                            let query = Buffer.from(
                            JSON.stringify({"tipoGestion":datosGestion && datosGestion.datosGestion[0]["codTipoGestion"],
                              "ambitoGestion":e.target.value, 
                              "idModoIngreso":238001
                            })).toString('base64')
                            dispatch(obtenerComboInstanciaGestion(query))
                            setIsInstancia(false)
                            setCodIntanciaGestion(233001)                  
                         }
                        setIsAmbito(e.target.value!=='' && !isAmbito) 
                        }}
                        name='codAmbitoGestion'
                        value={(formik.values.codAmbitoGestion = codAmbitoGestion)}
                        error={formik.errors.codAmbitoGestion}
                      >
                        <option value={''}>Seleccione...</option>
                        { !esAbogado ? comboAmbitoGestion &&
                          comboAmbitoGestion.comboAmbitoGestion?.filter(f=>f.id===232001).map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.nombre}
                            </option>
                          )):comboAmbitoGestion && comboAmbitoGestion.comboAmbitoGestion?.map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.nombre}
                            </option>
                          ))}
                      </Form.Select>
                      {formik.errors.codAmbitoGestion ? (
                        <Form.Text variant='danger' style={{ color: 'red' }}>
                          {formik.errors.codAmbitoGestion}
                        </Form.Text>
                      ) : (
                        ''
                      )}                      
                    </Col>
                    <Col md="3">
                      <Form.Label
                        className='mb-0  mt-3'
                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                      >
                        {
                          cfg_form41.cfg_form41[
                            'recepcasoasignadodef-cmb-instgest'
                          ]
                        }
                      </Form.Label>
                      <br />
                      <Form.Select
                        className='mt-2'
                        aria-label='Default select example'
                        disabled={isInstancia}
                        onChange={(e) => {
                          formik.handleChange(e)
                          setCodIntanciaGestion(e.target.value)
                          
                         
                        }}
                        name='codIntanciaGestion'
                        value={(formik.values.codIntanciaGestion = codIntanciaGestion)}
                        error={formik.errors.codIntanciaGestion}
                      >
                        <option value={''}>Seleccione...</option>
                        {comboInstanciaGestion &&
                          comboInstanciaGestion.comboInstanciaGestion?.map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.nombre}
                            </option>
                          ))}
                      </Form.Select>
                      {formik.errors.codIntanciaGestion ? (
                        <Form.Text variant='danger' style={{ color: 'red' }}>
                          {formik.errors.codIntanciaGestion}
                        </Form.Text>
                      ) : (
                        ''
                      )}
                      {/* {formik.errors.direccionImplicado ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.direccionImplicado}
                    </Form.Text>
                  ) : (
                    ''
                  )} */}
                    </Col>

                    <Col md="2">
                      <Form.Label
                        className='mb-0  mt-3'
                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                      >
                        {
                          cfg_form41.cfg_form41[
                            'recepcasoasignadodef-input-fechaaud'
                          ]
                        }
                      </Form.Label>
                      <br />
                      <Form.Control
                    className='mt-2 mb-4'
                   
                    type='date'
                    value={(formik.values.fechaAudiencia = fechaAudiencia)}
                    // min={
                    //   fechaSiniestro &&
                    //   convertirFecha(fechaSiniestro && fechaSiniestro)
                    // }
                    // max={hoy()}
                    name='fechaAudiencia'
                    onChange={(e) => {
                      formik.handleChange(e)
                      setFechaAudiencia(e.target.value)
                    }}
                    error={formik.errors.fechaAudiencia}
                  ></Form.Control>
                  {formik.errors.fechaAudiencia ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.fechaAudiencia}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                    </Col>
                    <Col md="2">
                      <Form.Label
                        className='mt-3'
                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                      >
                        {cfg_form41.cfg_form41['recepcasoasignadodef-lbl-estado']}
                      </Form.Label>
                      <br />
                      <Form.Text className="mt-3">
                      {datosGestion &&
                        datosGestion.datosGestion[0]['estado'] !== undefined &&
                        datosGestion.datosGestion[0]['estado'] !== null &&
                        datosGestion.datosGestion[0]['estado'] !== ''
                        ? datosGestion.datosGestion[0]['estado']
                        : ''}
                    </Form.Text>
                     
                    </Col>
                    <Col>
                        {respuestaRecepcion && 
                            <Mensajes
                                showToast={showToast}
                                handleCloseToast={handleCloseToast}
                                delay={5000}
                                responseData={respuestaRecepcion.respuestaRecepcion}
                            ></Mensajes>
                        }
                      </Col>
                  </Row>
                </div>
              ) : null}
            </Container>
          </Container>
        </Card>
      
      </Container>
    </>
  )
}

export default AdministraciónCaso
